// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__epWoa","modal":"Modal_modal__IlM5A","slide-down":"Modal_slide-down__gG+qC"};